import {useEffect, useState} from 'react';
import {BRAND} from '../brand';
import {useDesktop} from './DesktopContext';
import {LanguageSwitcher, useI18n} from '../i18n';

function useClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  return now;
}

/**
 * The top bar, with no fake menus.
 */
export function MenuBar() {
  const {activeAppName, windows} = useDesktop();
  const {t, locale} = useI18n();
  const now = useClock();
  const open = windows.filter((win) => !win.minimized).length;

  return (
    <header className="bar fixed inset-x-0 top-0 z-[9000] flex h-9 items-center justify-between px-4 text-[12px] text-ink-2">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex h-5 w-5 items-center justify-center rounded-md bg-accent text-[11px] font-bold text-accent-ink">
          {BRAND.name.slice(0, 1)}
        </span>
        <span className="font-bold tracking-tight text-ink">{t('brand.name') || BRAND.name}</span>
        <span className="hidden text-ink-3 sm:inline">{t('brand.tagline') || BRAND.tagline}</span>
        {activeAppName ? <span className="truncate text-ink-2">· {activeAppName}</span> : null}
      </div>

      <div className="flex items-center gap-4">
        <span className="hidden tabular-nums text-ink-3 sm:inline">
          {t('menu.windowsOpen', {count: open}) || `${open} cửa sổ đang mở`}
        </span>
        <LanguageSwitcher />
        <time className="font-semibold tabular-nums text-ink">
          {now.toLocaleDateString(locale, {day: '2-digit', month: '2-digit'})}{' '}
          {now.toLocaleTimeString(locale, {hour: '2-digit', minute: '2-digit'})}
        </time>
      </div>
    </header>
  );
}
